import axios from 'axios';

// Set your base URL here (replace with your actual backend URL)
const BASE_URL = `${process.env.REACT_APP_API_URL}/api/attractions`; // Updated the base URL to include attractions

// Function to get all attractions
export const fetchAttractions = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/all`); // Updated endpoint
    return response.data; // Ensure this matches the structure of your backend response
  } catch (error) {
    console.error('Error fetching attractions:', error);
    throw error;
  }
};

// Function to create an attraction
export const createAttraction = async (formData) => { // Accept formData directly
  try {
    const response = await axios.post(`${BASE_URL}/create`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set content type for file uploads
      },
    });
    return response.data; // Return the created attraction data
  } catch (error) {
    console.error('Error creating attraction:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Function to update an attraction
export const updateAttraction = async (id, formData) => {
  try {
    const response = await axios.put(`${BASE_URL}/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set content type for file uploads
      },
    });
    console.log('Response from update:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error updating attraction:', error.response || error.message);
    throw error;
  }
};

// Function to delete an attraction (no authentication token required)
export const deleteAttraction = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/${id}`); // Updated endpoint
    return response.data;
  } catch (error) {
    console.error('Error deleting attraction:', error);
    throw error;
  }
};

// Optionally, create a function for fetching a single attraction by ID
export const getAttractionById = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}/${id}`); // Updated endpoint
    return response.data;
  } catch (error) {
    console.error('Error fetching attraction by ID:', error);
    throw error;
  }
};